module.exports = __webpack_public_path__ + "static/11-84ce24ff0bf720177781b6f226f06083.jpg";